import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/services/data.service';
import { AlertDialogComponent, ConfirmDialogModel } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserProfileService } from 'src/app/core/http/user-profile.service';
import * as moment from 'moment';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent implements OnInit {
  activeClass = 'UpComing';
  tabVal: any;
  notificationData = [];
  upCommingNotifiationsActive = true;
  displayNotifications = [];
  upcommingNotifications = [];
  pastNotifications = [];
  userObject;
  constructor(private router: Router, private ds: DataService, public dialog: MatDialog, private userProfileService: UserProfileService) { }

  ngOnInit(): void {
    this.tabVal = 'UpComing';
    this.activeClass = 'UpComing';
    this.userObject = this.userProfileService.getLoggedinUserDetails();
    this.loadData();
  }
  createNotification() {
    this.router.navigate(['/add-notification']);
  }

  loadData() {
    this.ds.getService(environment.BASEURL + '/Notifications').subscribe(res => {
      if (res && res.length > 0) {
        this.notificationData = res;
        this.processData();
      }
    });
  }
  processData() {
    if (this.notificationData && this.notificationData.length > 0) {
      const currentDateTime = new Date();
      const thresholdTime: number= 900000;
      this.upcommingNotifications = this.notificationData.filter(x =>  new Date(moment.utc(x.publishDateTime).local().format('L LT')).getTime() > currentDateTime.getTime()+thresholdTime);
      this.pastNotifications = this.notificationData.filter(x => new Date(moment.utc(x.publishDateTime).local().format('L LT')).getTime() < currentDateTime.getTime()+thresholdTime)
      this.displayNotifications = this.upcommingNotifications;
      this.upCommingNotifiationsActive = true;
    }
  }

  showUpcommingNotifications() {
    this.displayNotifications = this.upcommingNotifications;
    this.upCommingNotifiationsActive = true;
  }
  showPastNotifications() {
    this.displayNotifications = this.pastNotifications;
    this.upCommingNotifiationsActive = false;
  }
  modifyNotification(item) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        notificationId: item.id
      }
    };
    this.router.navigate(['/add-notification'], navigationExtras);
  }
  deleteNotification(notification) {
    const dialogData = new ConfirmDialogModel('SMTH Portal', 'Are you sure that you want to delete the Notification?', 'confirm');
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      height: '250px',
      width: '600px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ds.deleteService(environment.BASEURL + `/NotificationStatus/${notification.id}`, {})
          .subscribe(res => {
            this.loadData();
          });
      }
    });
  }

}
